import type { DataTableRow } from "@client-shared";
import type { LabelPrintBatch } from "@shared/types";
import type { CellContext } from "@tanstack/react-table";
import { isValid, parseISO } from "date-fns";
import { useTranslation } from "react-i18next";
import { setBatchesTableCellTestId } from "../batches-table.utils";

export const CreatedAtCellMarkup = (props: CellContext<DataTableRow<LabelPrintBatch>, unknown>) => {
  const { t } = useTranslation();
  const createdAt = props.row.original.createdAt;
  const testId = setBatchesTableCellTestId("createdAt", props.row.index);
  const parsedDate = createdAt ? parseISO(createdAt) : null;

  if (!parsedDate || !isValid(parsedDate)) {
    return (
      <span className="text-sm text-muted-foreground" data-testid={testId}>
        —
      </span>
    );
  }

  return (
    <span className="text-sm text-muted-foreground" data-testid={testId}>
      {t("dates.monthdayyear", { date: parsedDate })}
    </span>
  );
};
